import React from 'react';
import Modal from 'react-modal';
import { SecondaryButton } from '@workday/canvas-kit-react/button';
import { autoId, useReactModal } from '@workday/upc-common';
import { ID_CHANGE_PASSWORD_BUTTON } from '../../../../autoIds';
import { ChangePasswordSteps } from './change-password-steps';
import { SettingsModalContent } from '../../../../shared/settings-modal-content/settings-modal-content';
import { useTranslation } from 'react-i18next';

export function ChangePasswordSettingsRow() {
    const changePasswordModal = useReactModal({ modalProps: { shouldCloseOnEsc: false } });

    const { t } = useTranslation('account');

    return (
        <div className='settingsRow'>
            <h1 className='settingsRow__title'>{t('ChangePasswordSettingsRow.title')}</h1>
            <div className='settingsRow__content'>
                <p>{t('ChangePasswordSettingsRow.description')}</p>
                <SecondaryButton
                    {...autoId(ID_CHANGE_PASSWORD_BUTTON)}
                    type='button'
                    onClick={changePasswordModal.open}>
                    {t('ChangePasswordSettingsRow.submitButton')}
                </SecondaryButton>
                <Modal {...changePasswordModal.modalProps}>
                    <SettingsModalContent>
                        <ChangePasswordSteps onClose={changePasswordModal.close} />
                    </SettingsModalContent>
                </Modal>
            </div>
        </div>
    );
}
